import { render, staticRenderFns } from "./PreConsent.vue?vue&type=template&id=16849ed2&"
import script from "./PreConsent.vue?vue&type=script&lang=ts&"
export * from "./PreConsent.vue?vue&type=script&lang=ts&"
import style0 from "./PreConsent.vue?vue&type=style&index=0&id=16849ed2&prod&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports